import React, { useEffect, useState } from "react";
import Financial from "./Financial";
import ProductServices from "./productServices";
import NewsDevelopments from "./newsDevelopments";
import Navbar from "../layout/Navbar";
import RelevantReports from "../reportType/RelevantReports";
import "../../../src/index.css";
import Footer from "../layout/Footer";
import { useLocation } from "react-router-dom";
import {
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Line,
  LabelList,
} from "recharts";
import axiosClient from "../../axios-client";

const TetraTechInc = () => {
  const location = useLocation();
  const companyData = location.state?.company; // Retrieve the passed company data
  const [activeTab, setActiveTab] = useState("overview");
  const [relatedReports, setRelatedReports] = useState([]);
  const fetchAllreportsByCompany_id = async () => {
    try {
      const response = await axiosClient.get(
        `/company/getallreportsbycompany_id/${companyData._id}`
      );
      if (response?.status === 200) {
        setRelatedReports(response?.data?.reports);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  useEffect(() => {
    fetchAllreportsByCompany_id();
  }, []);

  const revenueData = companyData.revenue.map((item) => ({
    year: item.year,
    value: item.value,
    percent: (item.value / companyData.revenue[0].value) * 100, // Calculate the percentage change based on the first year's value
  }));
  const tabs = {
    overview: (
      <div className="p-0 bg-white shadow-md rounded  md:p-4">
        <h2 className="text-lg font-bold mb-2">Overview</h2>
        <p className="company-details16">
          {companyData.overview}
          {/* XYZ Corporation is a global leader in innovative solutions, providing
          a wide range of products and services across multiple industries
          including technology, manufacturing, and consumer goods. With a focus
          on sustainability and cutting-edge technology, XYZ is dedicated to
          delivering high-quality, impactful solutions to clients worldwide. */}
        </p>

        <div className="flex flex-wrap mt-6">
          <div className="w-full md:w-1/2 pr-2 text-center sm:text-left">
            <h3 className="company-details6">Parent Company</h3>
            <p className="company-details16 mt-1">{companyData.companyName}</p>
          </div>
          <div className="w-full md:w-1/3 pl-0 md:pl-20 text-center sm:text-left">
            <h3 className="company-details6">Company Type</h3>
            <p className="company-details16 mt-1">{companyData.companyType}</p>
          </div>
          <div className="w-full md:w-2/4 pr-2 mt-4 text-center sm:text-left">
            <h3 className="company-details6">Subsidiary</h3>
            <p className="company-details16 mt-1">{companyData.subsidiary}</p>
          </div>
          <div className="w-full md:w-1/2 pl-0 md:pl-20 mt-4 text-center md:text-left">
            <h3 className="company-details6">Headquarter</h3>
            <p className="company-details16 mt-1">{companyData.headquarter}</p>
          </div>
        </div>
      </div>
    ),
    // financial: <Financial />,
    // productServices: <ProductServices />,
    newsDevelopments: <NewsDevelopments />,
  };

  return (
    <>
      <div className="min-h-screen bg-blue-50 flex flex-col md:flex-row p-7">
        <div className="w-full md:w-4/5 pr-2 mb-20">
          <div className="flex items-center">
            <h1 className="company-details mr-4 ">{companyData.companyName}</h1>
            <img
              src="./images/grade.png"
              alt="Description"
              className="h-8 w-8"
            />
          </div>

          <div className="mt-7">
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-7 company-details1 mb-2 toggling ml-3">
              {[
                { key: "overview", displayName: "Overview" },
                { key: "financial", displayName: "Financial" },
                { key: "productServices", displayName: "Product/Services" },
                {
                  key: "newsDevelopments",
                  displayName: "News/Recent Developments",
                },
              ].map((tab, index) => (
                <div className="relative" key={tab.key}>
                  <span
                    className={`cursor-pointer text-sm md:text-base ${
                      activeTab === tab.key
                        ? "font-bold text-pink-500"
                        : "text-gray-700"
                    }`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.displayName}
                  </span>
                  {activeTab === tab.key && (
                    <div
                      className={`absolute left-0 right-0 h-[2px] bg-pink-500 bottom-0 transition-all duration-300 w-[30%] sm:w-full`}
                      style={{
                        top: "calc(100% + 6px)",
                      }}
                    />
                  )}
                </div>
              ))}
            </div>

            {tabs[activeTab]}

            {activeTab === "overview" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <div className="bg-white shadow-md rounded p-4">
                  <h3 className="company-details6 mb-1">Market Relevance</h3>
                  <p className="company-details16 mb-4">
                    {companyData.marketRelevance}
                  </p>

                  <h3 className="company-details6 mb-1">Competitors</h3>
                  <p className="company-details16 mb-4">
                    {companyData.competitors}

                    <br />
                  </p>

                  <h3 className="company-details6 mb-1">Establishment Year</h3>
                  <p className="company-details16 mb-4">
                    {companyData.establishmentYear}
                  </p>

                  <h3 className="company-details6 mb-1">Employee Size</h3>
                  <p className="company-details16 mb-4">
                    {companyData.employeeSize}
                  </p>
                </div>

                <div className="bg-white shadow-md rounded p-4">
                  <h3 className="company-details6 mb-1">Address</h3>
                  <p className="company-details16 mb-4">
                    {companyData.address} <br />
                  </p>

                  <h3 className="company-details6 mb-1">Contact Number</h3>
                  <p className="company-details16 mb-4">
                    {companyData.contactNo}
                  </p>

                  <h3 className="company-details6 mb-1">Website</h3>
                  <p className="company-details16 mb-4 text-xs md:text-base">
                    {companyData.website}
                  </p>
                </div>
              </div>
            )}
            {activeTab === "financial" && (
              <div className=" ">
                {/* <h1 className="chart ml-2 text-lg md:text-xl lg:text-2xl">Revenue</h1> */}
                <div className="w-[128%] max-w-8xl mx-auto bg-white">
                  <h1 className="chart ml-2 text-lg md:text-xl lg:text-2xl mb-2 p-5">
                    Revenue
                  </h1>
                  <ResponsiveContainer width="100%" height={300}>
                    <ComposedChart data={revenueData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="year" tickLine={false} axisLine={false} />
                      <YAxis yAxisId="left" axisLine={false} tickLine={false} />
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => `${value.toFixed(1)}%`}
                      />
                      <Tooltip />
                      <Bar
                        dataKey="value"
                        fill="#923351"
                        width={50}
                        yAxisId="left"
                        shape={(props) => {
                          const { x, y, width, height } = props;
                          return (
                            <g>
                              <defs>
                                <filter
                                  id="shadow"
                                  x="-20%"
                                  y="-20%"
                                  width="140%"
                                  height="140%"
                                >
                                  <feDropShadow
                                    dx="2"
                                    dy="2"
                                    stdDeviation="3"
                                    floodOpacity="0.3"
                                  />
                                </filter>
                              </defs>
                              <rect
                                x={x}
                                y={y}
                                width={width}
                                height={height}
                                rx={5}
                                ry={5}
                                fill="#923351"
                                filter="url(#shadow)"
                              />
                            </g>
                          );
                        }}
                        barSize={50}
                        barGap={20}
                      >
                        <LabelList
                          dataKey="value"
                          position="top"
                          fill="#000000"
                          fontFamily="Poppins, sans-serif"
                        />
                      </Bar>
                      <Line
                        type="monotone"
                        dataKey="percent"
                        stroke="#ff9c40"
                        strokeWidth={2}
                        dot={{ r: 0 }}
                        yAxisId="right"
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}
            {activeTab === "productServices" && (
              <div className="mr-14 overflow-x-auto sm:overflow-visible">
                <table
                  className="table-auto border-collapse bg-white"
                  style={{ width: "130%" }}
                >
                  <thead>
                    <tr>
                      <th className="border border-gray-300 px-4 py-2 text-left w-[30%] product1">
                        Products
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left product1">
                        Specification
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {companyData.productsAndServices.map((product) => (
                      <tr key={product._id}>
                        <td className="border border-gray-300 px-4 py-4 pt-3 align-top product1">
                          {product.name}
                        </td>
                        <td className="border border-gray-300 px-4 py-2 product2">
                          {product.details.map((detail, index) => (
                            <p key={index} className="mb-4">
                              {detail}
                            </p>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {activeTab === "overview" && (
          <div className="w-full md:w-[360px] ml-0 md:ml-5 mt-8 md:mt-24 mb-8">
            <RelevantReports relatedReports={relatedReports} />
          </div>
        )}
      </div>
    </>
  );
};

export default TetraTechInc;
